import script from "./work.vue?vue&type=script&setup=true&lang=js"
export * from "./work.vue?vue&type=script&setup=true&lang=js"

import "./work.vue?vue&type=style&index=0&id=42078cfa&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42078cfa"]])

export default __exports__